/**
 * @file [[...taxonomy]].tsx
 *
 * @fileoverview Job search page, can be accessed by going to /jobs.
 * The job displays the full job search page, and automatically generates que query to solr via the parameters found
 * in the URL.
 */
import JobiqoJobPage, { getServerSideProps } from '~/jobiqo/pages/jobs';
export default JobiqoJobPage;
export { getServerSideProps };
